import { landingImages, LandingSvg } from 'assets';


export const abaBillingFeatures = [
    {
        id: "billing-guardrails",
        title: "Billing Guardrails That Help Catch Mistakes Before They Cost You",
        text: "TherapyLake helps catch billing issues early, starting with scheduling and continuing through claims." +
            " Built-in workflows, warnings, and error checks guide teams before mistakes turn into lost revenue.",
        bullets: [
            "Help prevent billing mistakes starting at scheduling",
            "Catch missing or incorrect details before claims move forward",
            "Guide staff with built-in workflows, alerts, and error checks",
            "Reduce rework caused by authorization, appointment, or documentation issues",
        ],
        BadgeIcon: LandingSvg.ArchiveTickSvg,
        badgeLabel: 'PREVENT ISSUES EARLY',
        imageSmall: landingImages.abaBillingGuardrailsImgSmall,
        image: landingImages.abaBillingGuardrailsImg,
    },
    {
        id: "rcm-agents",
        title: "Built With Experienced RCM Agents and Billing Teams",
        text: "TherapyLake is shaped by experienced RCM agents and billing professionals." +
            " We keep improving the billing experience for small clinics, growing teams, and large ABA practices.",
        bullets: [
            "Built with feedback from experienced RCM agents and billing teams",
            "Continuously improved around real ABA billing workflows",
            "Supports small clinics, growing teams, and larger practices",
            "Help billing teams work with clearer processes and fewer manual gaps",
        ],
        BadgeIcon: LandingSvg.PeopleSvg,
        badgeLabel: 'IMPROVE CONTINUOUSLY',
        imageSmall: landingImages.abaBillingRcmAgentsImgSmall,
        image: landingImages.abaBillingRcmAgentsImg,
    },
    {
        id: "automated-claims",
        title: "Automated Claim Submissions, ERAs, and Payment Posting",
        text: "Claim submissions, ERAs, and payment posting are automated and integrated with clearinghouse workflows." +
            " Teams can move from submission to payment with less manual work.",
        bullets: [
            "Automate claim submissions through integrated clearinghouse workflows",
            "Connect ERAs directly into billing and payment workflows",
            "Streamline payment posting and reconciliation activity",
            "Reduce manual entry and disconnected billing handoffs",
        ],
        BadgeIcon: LandingSvg.ReceiptSvg,
        badgeLabel: 'AUTOMATE THE FLOW',
        imageSmall: landingImages.abaBillingAutomatedImgSmall,
        image: landingImages.abaBillingAutomatedImg,
    },
    {
        id: "eligibility-checks",
        title: "Built-In Eligibility Checks to Help Prevent Revenue Loss",
        text: "TherapyLake helps teams verify eligibility before services are rendered." +
            " This helps prevent avoidable denials, coverage issues, and lost revenue.",
        bullets: [
            "Check eligibility before services are rendered",
            "Help prevent sessions for clients who may no longer be eligible",
            "Reduce avoidable denials tied to coverage issues",
            "Protect revenue by catching eligibility problems earlier",
        ],
        BadgeIcon: LandingSvg.PersonalCardSvg,
        badgeLabel: 'VERIFY BEFORE YOU SERVE',
        imageSmall: landingImages.abaBillingEligibilityImgSmall,
        image: landingImages.abaBillingEligibilityImg,
    },
    {
        id: "custom-reporting-2",
        title: "Custom Reports, KPIs, and a Transparent Receivables Dashboard",
        text: "Custom reports, KPIs, and a transparent receivables dashboard help teams track billing health," +
            " manage claims, and stay organized in one place.",
        bullets: [
            "Track custom billing reports and revenue KPIs",
            "Monitor the health of receivables with greater transparency",
            "Manage claims, follow-up, and payment activity in one dashboard",
            "Help teams stay organized across open claims and outstanding balances",
        ],
        BadgeIcon: LandingSvg.DiagramSvg,
        badgeLabel: 'SEE THE HEALTH OF RECEIVABLES',
        imageSmall: landingImages.abaBillingReportingImgSmall,
        image: landingImages.abaBillingReportingImg,
    },
    {
        id: "connected-billing",
        title: "Billing Connected to Authorizations, Appointments, and Sessions",
        text: "TherapyLake keeps billing connected to authorizations, appointments, sessions, notes, and client records." +
            " When issues happen, teams can trace them back faster.",
        bullets: [
            "Trace billing issues back to authorizations, appointments, and session records",
            "Keep documentation, scheduling, and billing connected in one system",
            "Find mistakes faster when claims need review or correction",
            "Reduce back-and-forth between clinical, admin, and billing teams",
        ],
        BadgeIcon: LandingSvg.LinkSvg,
        badgeLabel: 'CONNECTED TO THE WHOLE PRACTICE',
        imageSmall: landingImages.abaBillingConnectedImgSmall,
        image: landingImages.abaBillingConnectedImg,
    },
    {
        id: "rcm-services",
        title: "Optional RCM Services for TherapyLake Clients",
        text: "TherapyLake clients can also access optional RCM services at highly competitive rates." +
            " Get experienced billing support while keeping workflows connected to the platform.",
        bullets: [
            "Access optional RCM services available to TherapyLake clients",
            "Get help from experienced billing and revenue cycle professionals",
            "Reduce the burden on internal billing teams",
            "Keep managed billing work connected to the same system your practice uses daily",
        ],
        BadgeIcon: LandingSvg.OnlineSupportSvg,
        badgeLabel: 'NEED EXTRA HELP?',
        imageSmall: landingImages.abaBillingRcmServicesImgSmall,
        image: landingImages.abaBillingRcmServicesImg,
    },
];


export const abaBillingFaqs = [
    {
        title: "Does TherapyLake support ABA billing workflows?",
        description: "Yes. TherapyLake supports claim submissions, eligibility checks, claim status checks," +
            " payments, follow-up work, reporting, and revenue cycle visibility.",
    },
    {
        title: "Can TherapyLake reduce billing tool switching?",
        description: "Yes. TherapyLake connects billing activity with sessions, records, claims, payments," +
            " and follow-up work in one platform.",
    },
    {
        title: "Is TherapyLake built for ABA billing teams?",
        description: "Yes. TherapyLake is built around ABA workflows, including scheduling, documentation," +
            " authorizations, claims, payments, reporting, and RCM support.",
    },
];
